export class JobProgressStepDatabaseDataBackupData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "isFullBackup",
            "baseName": "isFullBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "asyncParquetExport",
            "baseName": "asyncParquetExport",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "noNativeSnapshot",
            "baseName": "noNativeSnapshot",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceSizeBytes",
            "baseName": "sourceSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepDatabaseDataBackupData.attributeTypeMap;
    }
    constructor() {
    }
}
